import { isQuarterPoint, QUARTER_MESSAGE, weekGoalError } from "@/lib/points";
import type { MealDiaryConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";
import { maxScoreWeek } from "./scoring";

export function validate(config: MealDiaryConfig): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  if (!Number.isFinite(config.points)) {
    errors.points = "Poeng kreves.";
  } else if (config.points <= 0) {
    errors.points = "Poeng må være over 0.";
  } else if (!isQuarterPoint(config.points)) {
    errors.points = QUARTER_MESSAGE;
  }
  const goalError = weekGoalError(config.weekGoal, {
    max: maxScoreWeek(config),
  });
  if (goalError) errors.weekGoal = goalError;
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
